import { AfterViewInit, Component, DoCheck, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { WorkshopJobcardAddCouponComponent } from './workshop-jobcard-add-coupon/workshop-jobcard-add-coupon.component';
import { WorkshopJobcardCreateSpecialOrderComponent } from './workshop-jobcard-create-special-order/workshop-jobcard-create-special-order.component';
import { WorkshopJobcardEditLineitemComponent } from './workshop-jobcard-edit-lineitem/workshop-jobcard-edit-lineitem.component';
import { WorkshopJobcardAddLineitemNoteComponent } from './workshop-jobcard-add-lineitem-note/workshop-jobcard-add-lineitem-note.component';
import { WorkshopJobcardQuoteOptionsComponent } from './workshop-jobcard-quote-options/workshop-jobcard-quote-options.component';
import { WorkshopJobcardQuoteService } from './workshop-jobcard-quote.service';
import { WorkshopJobcardCreateService } from '../workshop-jobcard-create.service';
import { CouponCalculatorService } from './workshop-jobcard-add-coupon/coupon-calculator.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceService } from 'src/app/services/invoice.service';
import { UserService } from 'src/app/services/user.service';
import { MessageService } from 'primeng/api';
import { ServiceRequestService } from 'src/app/services/servicerequest.service';
import { SpecialOrdersService } from 'src/app/services/specialorders.service';
import { InvoiceOptionsService } from 'src/app/services/invoice-options.service';
import { PartnerService } from 'src/app/services/partner.service';
import { AppConfig } from 'src/app/app.config';
import { WorkshopJobcardUpdateCustomerItemComponent } from '../workshop-jobcard-item-details/workshop-jobcard-update-customer-item/workshop-jobcard-update-customer-item.component';
import { WorkshopJobcardListCustomerItemsComponent } from '../workshop-jobcard-item-details/workshop-jobcard-list-customer-items/workshop-jobcard-list-customer-items.component';
import { WorkshopJobcardAddCustomerItemComponent } from '../workshop-jobcard-item-details/workshop-jobcard-add-customer-item/workshop-jobcard-add-customer-item.component';
import { Project529ModalComponent } from 'src/app/components/modals/project529-modal/project529-modal.component';
import { Project529Service } from 'src/app/services/project529.service';
import { BroadcastService } from 'src/app/services/broadcast.service';

@Component({
  selector: 'app-workshop-jobcard-quote',
  templateUrl: './workshop-jobcard-quote.component.html',
  styleUrls: ['./workshop-jobcard-quote.component.scss'],
  providers: [MessageService]
})
export class WorkshopJobcardQuoteComponent implements AfterViewInit, OnChanges, DoCheck {

  @Input() jobcard: any = {};
  @Input() serviceTypes: any[] = [];
  @Input() productSKUServiceTypeCollection: any = [];
  @Input() isPhoneView: boolean = false;
  @Output() jobcardChange = new EventEmitter<any>();
  @Output() ownerChanged = new EventEmitter<any>();
  @Output() sendingToPOSChange = new EventEmitter<boolean>();

  public partnerData: any = {};
  public currencySymbol: string = "$";
  public vatInclusive: boolean = true;
  public canDoSpecialOrder: boolean = false;
  public canAddCoupon: boolean = false;
  private _previousJobcardState: any = null;
  public lightSpeedDiscounts: any[] = [];
  public sendingApproval: boolean = false;
  public sendToThirdPartyOnly: boolean = true;
  public showTakingTooLong: boolean = false;
  private _sendingToPOS: boolean = false;
  public get sendingToPOS(): boolean {
    return this._sendingToPOS;
  }
  public set sendingToPOS(value: boolean) {
    if (this._sendingToPOS === value) return;
    this._sendingToPOS = value;
    this.sendingToPOSChange.emit(value);
  }
  public selectItemsForSpecialOrder: boolean = false;
  public specialOrderItems: any[] = [];
  public loadingQuote: boolean = false;
  public popupWindow: any;
  public invoiceOptions: any[] = [];
  public loadingQuoteOptions: boolean = false;
  public shortCode: any;
  public useWorkOrdersForWorkshop: boolean = false;

  constructor(
    public helpersService: HelpersService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private couponCalculatorService: CouponCalculatorService,
    private invoiceService: InvoiceService,
    private userService: UserService,
    private messageService: MessageService,
    private serviceRequest: ServiceRequestService,
    private workshopJobcardQuoteService: WorkshopJobcardQuoteService,
    private workshopJobcardCreateService: WorkshopJobcardCreateService,
    private specialOrdersService: SpecialOrdersService,
    private invoiceOptionsService: InvoiceOptionsService,
    private partnerService: PartnerService,
    private appConfig: AppConfig,
    private project529Service: Project529Service,
    public broadcastService: BroadcastService
  ) { }

  ngOnInit() {
    this.partnerData = this.helpersService.getPartnerData();
    this.currencySymbol = this.partnerData?.CurrencySymbol || '$';
    this.vatInclusive = this.partnerData?.VATInclusive;
    this.canDoSpecialOrder = this.partnerData.POSSystemID === 6;    
    this.canAddCoupon = this.partnerData.AllowDiscount;
    if(this.partnerData.POSSystemID === 6 && this.partnerData.UseWorkOrders
      && (!this.jobcard.quote?.externalKey || this.jobcard.quote?.externalKey === '0' || !!this.jobcard.quote?.workOrderID)
    ){
      this.useWorkOrdersForWorkshop = true;
    }else if(this.partnerData.POSSystemID === 6 && !this.partnerData.UseWorkOrders && this.jobcard.quote.workOrderID){
      //This is for when a store might have disabled work orders after the quote was created, we still linked to the work order to show the workorder UI
      this.useWorkOrdersForWorkshop = true;
    }

    if (this.partnerData.POSSystemID === 6) {
      this.getLightSpeedDiscounts();
    }

    if (this.partnerData.POSSystemID === 17) {
      this.canAddCoupon = false;
    }

    if (!this.jobcard.quote) {
      this.jobcard.quote = { lineItems: [] }
    }
    if (!this.jobcard.quote.lineItems) {
      this.jobcard.quote.lineItems = [];
    }

    if (this.jobcard.id) {
      this.getInvoice(() => {
        this.getInvoice(() => {
          return;
        }, true);
        return;
      }, false);

      this.getProject529Status();
    }

    this.getInvoiceOptions();
    this.getShortCode();

    if(this.jobcard.id && this.jobcard.quote?.workOrderID){
      this.manageInvoicePOSExtras();
    }

  }

  ngAfterViewInit(): void { }

  ngDoCheck(): void {   
    if (this.jobcard.id && this.jobcard?.quote?.id) {
      const currentState = JSON.stringify(this.jobcard?.quote?.lineItems || []);
      if (currentState !== this._previousJobcardState && this._previousJobcardState !== null) {        
        const previousLineItems = JSON.parse(this._previousJobcardState);
        const currentLineItems = JSON.parse(currentState);

        if (this.jobcard.quote?.lineItems?.length > 0 && this.jobcard.quote.lineItems.filter(item => !item.ID)) {
          var lineItem = this.jobcard.quote.lineItems.filter(item => !item.ID).pop();
          if (lineItem) {
            console.log('LINE_ITEM_ADDED:', lineItem);
            this.handleQuoteUpdates('LINE_ITEM_ADDED', lineItem);
          }
        }


        const changedItems = currentLineItems.filter((currentItem: any) => {
          var previousItem = previousLineItems.find((item: any) => (!item.ID && item.InternalProductID === currentItem.InternalProductID) || (item.ID && item.ID === currentItem.ID));
          if(previousItem && !previousItem.Discount) previousItem.Discount = 0;
          if(previousItem && !previousItem.DiscountID) previousItem.DiscountID = 0;

          return currentItem.HasBeenUpdated && previousItem &&
            (previousItem.Quantity !== currentItem.Quantity ||
              previousItem.UnitPrice !== currentItem.UnitPrice ||
              previousItem.UnitPrice_IncludingTax !== currentItem.UnitPrice_IncludingTax ||
              previousItem.Discount !== currentItem.Discount ||
              previousItem.DiscountID !== currentItem.DiscountID
            )
        });
        if (changedItems.length > 0) {
          console.log('LINE_ITEM_UPDATED:', changedItems[0]);
          this.handleQuoteUpdates('LINE_ITEM_UPDATED', changedItems[0]);
        }

        const changedNotes = currentLineItems.filter((currentItem: any) => {
          const previousItem = previousLineItems.find((item: any) => (!item.ID &&item.InternalProductID === currentItem.InternalProductID) || (item.ID && item.ID === currentItem.ID));
          return previousItem &&
            (previousItem.LineItemNote !== currentItem.LineItemNote && currentItem.LineItemNote !== null && currentItem.LineItemNote !== undefined)
        });
        if (changedNotes.length > 0) {
          console.log('LINE_ITEM_NOTE_UPDATED:', changedNotes[0]);
          this.handleQuoteUpdates('LINE_ITEM_NOTE_UPDATED', changedNotes[0]);
        }

        const removedItems = previousLineItems.filter((previousItem: any) => {
          return previousItem.ID && !currentLineItems.some((currentItem: any) => currentItem.ID === previousItem.ID && currentItem.ID > 0);
        });
        if (removedItems.length > 0) {
          console.log('LINE_ITEM_REMOVED:', removedItems[0]);
          this.handleQuoteUpdates('LINE_ITEM_REMOVED', removedItems[0]);
        }

        this._previousJobcardState = currentState;
      } else if (this._previousJobcardState === null) {
        this._previousJobcardState = currentState;
      }
    }else{
      this.calculateTotals();
    }
    this.workshopJobcardQuoteService.calculateServiceTypeHours(this.jobcard);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobcard'] && changes['jobcard'].currentValue?.quote) {      
      if (this.jobcard.quote.couponResponse && this.jobcard.quote.couponCode) {
        this.couponCalculatorService.applyCoupon(this.jobcard.quote.couponResponse, this.jobcard, this.vatInclusive);
      }
      this.calculateTotals();
      this.workshopJobcardQuoteService.calculateServiceTypeHours(this.jobcard);
    }
    if (changes['jobcard'] && changes['jobcard'].currentValue?.selectedServiceTypes) {     
      this.workshopJobcardQuoteService.calculateServiceTypeHours(this.jobcard);
    }
  }

  // Updated to use service
  calculateTotals() {
    this.workshopJobcardQuoteService.calculateTotals(this.jobcard, this.vatInclusive);
  }

  // Labour or Parts & Materials lines, in quote order. The section comes from the product's labour tick.
  sectionLines(isLabour: boolean) {
    return (this.jobcard?.quote?.lineItems || []).filter((x: any) => !!x.MarkedAsLabourProduct === isLabour);
  }

  // Same figures as calculateTotals, so the sections match the Sub-total (tax exclusive) or Total (tax inclusive)
  getSectionAmount(lineItems: any[]) {
    return lineItems.reduce((sum: number, x: any) => {
      const unitPrice = x.UnitPrice || 0;
      const price = this.vatInclusive ? (x.UnitPrice_IncludingTax || (unitPrice + (x.Tax || 0))) : unitPrice;
      return sum + +(price * (x.Quantity || 0)).toFixed(2) - (+x.TotalDiscount?.toFixed(2) || 0);
    }, 0);
  }

  getSKUDuration(sku: any) {
    if (sku.LinkedServiceTypes && sku.LinkedServiceTypes.length > 0) {
      return sku.LinkedServiceTypes.reduce((total: number, serviceType: any) => total + (serviceType.hours || 0), 0);
    } else {
      return 0;
    }
  }

  addCoupon() {
    const modalRef = this.modalService.open(WorkshopJobcardAddCouponComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.partnerData = this.partnerData;
    modalRef.componentInstance.vatInclusive = this.vatInclusive

    modalRef.result.then(
      (result) => {
        this.calculateTotals();
        if (this.jobcard.id) {
          this.saveCurrentLineItemState();
          this.serviceRequest.updateWorkshopJobCard(this.jobcard).subscribe((result) => {
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant('bikeshop.workshop.jobcard.coupon_applied_to_quote', { couponCode: this.jobcard.quote.couponCode })
            });
            this.manageInvoicePOSExtras(true);
          });
        } else {
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant('bikeshop.workshop.jobcard.coupon_applied_to_quote', { couponCode: this.jobcard.quote.couponCode })
          });
        }
      },
      (onrejected) => {
        this.calculateTotals();
      },
    );
  }

  saveCurrentLineItemState() {
    const currentState = JSON.stringify(this.jobcard?.quote?.lineItems || []);
    this._previousJobcardState = currentState;
  }

  // Updated to use service
  sendQuoteToPOS(manageStock: boolean, callback?: () => void) {
    this.showTakingTooLong = false;
    this.sendingToPOS = true;

    const showTakingTooLongTimeout = setTimeout(() => {
      if (this.sendingToPOS) {
        this.showTakingTooLong = true;
      }
    }, 10000);

    this.workshopJobcardQuoteService.sendQuoteToPOS(
      this.jobcard,
      this.partnerData,
      this.specialOrderItems,
      manageStock,
      () => this.showTakingTooLong = true,
      () => {
        this.sendingToPOS = false;
        this.showTakingTooLong = false;
        this.selectItemsForSpecialOrder = false;
        this.specialOrderItems = [];
        clearTimeout(showTakingTooLongTimeout);
      },
      callback,
      this.useWorkOrdersForWorkshop
    ).subscribe(
      () => {
        this.getInvoice(() => { }, true);
        this.sendNotesBroadcast();
      },
      (err) => {
        this.sendingToPOS = false;
        this.showTakingTooLong = false;
        if (callback) callback();
        console.log(err);
      }
    );
  }

  // Updated to use service
  createSalesOrder(manageStock: boolean, callback?: () => void) {
    this.showTakingTooLong = false;
    this.sendingToPOS = true;

    const showTakingTooLongTimeout = setTimeout(() => {
      if (this.sendingToPOS) {
        this.showTakingTooLong = true;
      }
    }, 5000);

    this.workshopJobcardQuoteService.createSalesOrder(
      this.jobcard.quote.id,
      this.specialOrderItems,
      () => this.showTakingTooLong = true,
      () => {
        this.selectItemsForSpecialOrder = false;
        this.sendingToPOS = false;
        this.showTakingTooLong = false;
        clearTimeout(showTakingTooLongTimeout);
      },
      callback
    ).subscribe(
      () => {
        // Handle success
      },
      (err) => {
        this.sendingToPOS = false;
        this.showTakingTooLong = false;
        if (callback) callback();
      }
    );
  }

  getInvoice(callback: (() => void) | null, getInventory: boolean = false) {
    if (this.jobcard && this.jobcard.id) {
      this.loadingQuote = getInventory;
      this.invoiceService.getInvoiceV2(this.jobcard.id, getInventory).subscribe((invoice) => {
        this.mapOldQuoteToNewFormat(invoice, getInventory);
        if (getInventory) this.loadingQuote = false;
        if (callback !== null) {
          callback();
        }
      }, err => {
        this.loadingQuote = false;
      });
    }
  }

  // Updated to use service
  manageInvoicePOSExtras(updatePrices: boolean = false) {
    this.workshopJobcardQuoteService.manageInvoicePOSExtras(
      this.jobcard,
      updatePrices,
      () => this.loadingQuote = true,
      () => {
        this.loadingQuote = false;
        // The response can change discounts and prices (for example a coupon), so the totals need redoing
        this.calculateTotals();
        this.sendNotesBroadcast();
      }
    ).subscribe();
  }

  // Updated to use service
  mapOldQuoteToNewFormat(oldQuote: any, getInventory: boolean = false, updatePrices: boolean = false) {
    this.workshopJobcardQuoteService.mapOldQuoteToNewFormat(
      this.jobcard,
      oldQuote,
      getInventory,
      updatePrices,
      () => {
        this.saveCurrentLineItemState();
      }
    );
    this.calculateTotals();
    this.workshopJobcardQuoteService.calculateServiceTypeHours(this.jobcard);
  }


  // ... rest of the existing methods remain the same ...
  addLineItemNote(item: any, event) {
    event.stopPropagation();
    const modalRef = this.modalService.open(WorkshopJobcardAddLineitemNoteComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });
    modalRef.componentInstance.lineItem = item;
    modalRef.result.then(
      (result) => {
      });
  }

  getLightSpeedDiscounts() {
    this.invoiceService.getDiscounts(this.helpersService.getPartnerId()).subscribe((discounts) => {
      this.lightSpeedDiscounts = discounts;
    });
  }

  editLineItem(lineItem: any) {
    const modalRef = this.modalService.open(WorkshopJobcardEditLineitemComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window'
    });
    modalRef.componentInstance.lineItem = lineItem;
    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.vatInclusive = this.vatInclusive;
    modalRef.componentInstance.allowDiscount = this.partnerData.AllowDiscount;
    modalRef.componentInstance.lightSpeedDiscounts = this.lightSpeedDiscounts;

    modalRef.result.then(
      (result) => {
        this.calculateTotals();
      },
      (onrejected) => {
        this.calculateTotals();
      },
    );
    lineItem.showActions = false;
  }

  removeLineItem(lineItem: any, event) {
    event.stopPropagation();
    if (this.jobcard && this.jobcard.quote && this.jobcard.quote.lineItems) {
      const index = this.jobcard.quote.lineItems.indexOf(lineItem);
      if (index > -1) {
        var serviceTypesRemoved = false;
        if (this.jobcard.quote.lineItems[index].LinkedServiceTypes && this.jobcard.quote.lineItems[index].LinkedServiceTypes.length > 0) {
          this.jobcard.quote.lineItems[index].LinkedServiceTypes.forEach((serviceType: any) => {
            this.removeServiceType(serviceType, false);
            serviceTypesRemoved = true;
          });
        }
        this.jobcard.quote.lineItems.splice(index, 1);       
        this.calculateTotals();

        if (serviceTypesRemoved && !this.jobcard.id) {
          // New jobcard only: deleting a SKU that was linked to one or more service
          // types changes the work, so reallocate the technician + slot once.
          this.reallocateTechnicianForNewJob();
        }
      }
    }
    lineItem.showActions = false;
  }

  getUpdatedServiceTypes() {
    if (this.jobcard.id) {      
      this.serviceRequest.getManageJobCardLinkedServices(this.jobcard.id).subscribe((serviceTypes) => {
        this.jobcard.selectedServiceTypes = serviceTypes;
        this.workshopJobcardQuoteService.calculateServiceTypeHours(this.jobcard);
        //this.jobcard = { ...this.jobcard };
        this.jobcardChange.emit(this.jobcard);
      });
    }
  }

  createSpecialOrder() {
    const modalRef = this.modalService.open(WorkshopJobcardCreateSpecialOrderComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });
    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.currencySymbol = this.currencySymbol;
    modalRef.componentInstance.vatInclusive = this.vatInclusive;
    modalRef.componentInstance.partnerData = this.partnerData;
    modalRef.componentInstance.useWorkOrdersForWorkshop = this.useWorkOrdersForWorkshop;

    modalRef.result.then(
      (result) => {
        if (result.sentToPOS) {
          this.getInvoice(() => {

            if(this.useWorkOrdersForWorkshop){
              this.checkWindow();
            }else if (
              !this.useWorkOrdersForWorkshop &&
              this.jobcard.quote.externalKey !== null &&
              this.jobcard.quote.externalKey !== ''
            ) {
              var url =
                'https://us.merchantos.com/register.php?form_name=load_transaction&transaction_id=' +
                this.jobcard.quote.externalKey;
              if (
                this.partnerData.POSCustomURL &&
                this.partnerData.POSCustomURL.indexOf('{{SALEID}}') > -1
              ) {
                url = this.partnerData.POSCustomURL.replace(
                  '{{SALEID}}',
                  this.jobcard.quote.externalKey,
                );
              }

              this.popupWindow = window.open(
                url,
                'LightSpeed Sale',
                'toolbar=0,scrollbars=1,location=0,statusbar=1,menubar=0,resizable=0,width=1200,height=720',
              );
              this.checkWindow();
            }
          }, false);

        }
      },
      (onrejected) => {

      },
    );
  }

  checkWindow() {
    setTimeout(() => {
      if (!this.popupWindow || this.popupWindow?.parent === null) {
        this.loadingQuote = true;
        this.specialOrdersService
          .getSpecialOrdersV2(this.jobcard.partnerID, true)
          .subscribe((specialOrders) => {
            this.serviceRequest.waitingForParts(this.jobcard.id).subscribe((jobcard) => {
              this.jobcard.statusID = jobcard.StatusID;
              this.jobcardChange.emit(this.jobcard);
            })
            this.getInvoice(() => { });
          });
      } else {
        this.checkWindow();
      }
    }, 2000);
  }

  removeCoupon() {
    this.jobcard.quote.couponCode = '';
    this.jobcard.quote.couponDiscountType = '';
    this.jobcard.quote.couponDiscount = 0;
    this.jobcard.quote.couponResponse = null;
    this.jobcard.quote.lineItems.forEach((lineItem: any) => {
      lineItem.Discount = null;
      lineItem.TotalDiscount = null;
      lineItem.DiscountID = null;
      lineItem.DiscountType = null;
      lineItem.CouponDiscountApplied = false;
    });
    this.calculateTotals();

    if (this.jobcard.id) {
      this.saveCurrentLineItemState();
      this.serviceRequest.updateWorkshopJobCard(this.jobcard).subscribe((result) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('bikeshop.workshop.jobcard.coupon_removed_from_quote'),
        });
      });
    } else {
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant('bikeshop.workshop.jobcard.coupon_removed_from_quote'),
      });
    }
  }

  // reallocate defaults to true so the direct "remove service type" trash icon
  // re-runs availability. removeLineItem passes false while looping so it can
  // reallocate just once after all linked service types are removed.
  removeServiceType(serviceType: any, reallocate: boolean = true) {
    if (this.jobcard && this.jobcard.selectedServiceTypes) {
      const index = this.jobcard.selectedServiceTypes.findIndex((item: any) => {
        return item.serviceTypeID === serviceType.serviceTypeID;
      });
      if (index > -1) {
        var selectedServiceTypes = JSON.parse(JSON.stringify(this.jobcard.selectedServiceTypes));
        selectedServiceTypes.splice(index, 1);
        this.jobcard.selectedServiceTypes = selectedServiceTypes;
        this.jobcard = { ...this.jobcard };
        this.workshopJobcardQuoteService.calculateServiceTypeHours(this.jobcard);
        this.jobcardChange.emit(this.jobcard);

        if (reallocate && !this.jobcard.id) {
          // New jobcard only: the service-type set changed, so reallocate the
          // technician + slot for the reduced set.
          this.reallocateTechnicianForNewJob();
        }
      }
    }
  }

  // Re-queries Partner/{PartnerID}/Workshop/Availability for NEW jobcards only and
  // applies the resolved technician + schedule slot. This component has no technician
  // dropdown, so it passes an empty technicians list; jobcard.technician is still
  // resolved from the API result. technicianSpecific=false reallocates fresh (re-picks
  // a capable technician), and allocateFirstAvailable=true lands the slot on the
  // closest available date on/after the booking date.
  private reallocateTechnicianForNewJob(): void {
    // Hard guard: never touch an existing jobcard from this path.
    if (this.jobcard.id) {
      return;
    }
    // When both originalTechnician and originalScheduleDate are present the tech + date
    // were explicitly chosen from the calendar — never override either regardless of the
    // selected service types.
    if (this.jobcard.originalTechnician && this.jobcard.originalScheduleDate) {
      return;
    }

    const selectedServiceTypeIDs = (this.jobcard.selectedServiceTypes || [])
      .map((st: any) => st.serviceTypeID)
      .filter((id: any) => id != null);

    this.workshopJobcardCreateService
      .getAvailableSlots(this.jobcard, selectedServiceTypeIDs, [], false, true, true, this.jobcard.originalTechnician || 0)
      .subscribe({
        next: (result) => {
          if (result && result.jobcard) {
            this.jobcard = { ...result.jobcard };
            this.jobcardChange.emit({ ...this.jobcard });
          }
        },
        error: (error) => {
          console.error('Error reallocating technician for new jobcard:', error);
        }
      });
  }

  getInvoiceOptions() {
    if (this.partnerData.AllowMultipleQuoteOptions && this.jobcard && this.jobcard.id) {
      this.loadingQuoteOptions = true;
      this.invoiceOptionsService.getInvoiceOptions(this.jobcard.id).subscribe(
        (invoiceOptions) => {
          this.invoiceOptions = invoiceOptions;
          this.loadingQuoteOptions = false;
        },
        (err) => {
          this.invoiceOptions = [];
          this.loadingQuoteOptions = false;
        },
      );
    }
  }

  getQuoteOptionsStatus() {
    if (this.invoiceOptions.length === 0) return null;

    var approvalStatus = 0;
    this.invoiceOptions.forEach((option) => {
      if (option.approvalStatus === 1 && approvalStatus !== 10) {
        approvalStatus = 1
      } else if (option.approvalStatus === 2 && approvalStatus !== 10) {
        approvalStatus = 9;
      } else if (option.approvalStatus === 9 && approvalStatus !== 1 && approvalStatus !== 10) {
        approvalStatus = 9;
      } else if (option.approvalStatus === 10) {
        approvalStatus = 10;
      }
    });
    return approvalStatus;
  }

  openQuoteOptions() {

    const modalRef = this.modalService.open(WorkshopJobcardQuoteOptionsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });
    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.invoiceOptions = this.invoiceOptions;
    modalRef.componentInstance.update.subscribe((result) => {
      this.getInvoiceOptions();
    });

    modalRef.result.then(
      (result) => {

      },
      (onrejected) => {

      },
    );

  }

  sendQuoteToCustomer() {
    const partner = this.helpersService.getPartnerData();
    this.sendingApproval = true;
    this.userService.postAskApprovalV2(
      partner.ID,
      this.jobcard.customer.ID,
      this.jobcard.id,
      !this.jobcard.thirdPartyID ? null : this.sendToThirdPartyOnly,
    ).subscribe((res) => {
      this.sendingApproval = false;
      this.jobcard.quote.askForApproval = true;
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant('cyclist.approval_sent'),
      }), err => {
        this.sendingApproval = false;
      };
    });
  }

  hasApprovedLineItems() {
    return this.jobcard.quote?.lineItems.some((item: any) => item.Approved === 1 || item.Approved === 2);
  }

  handleQuoteUpdates(updateType: string, lineItem: any) {    
    if (this.jobcard.id) {
      if (updateType === 'LINE_ITEM_ADDED') {
        this.addLineItemCommit(lineItem);
      } else if (updateType === 'LINE_ITEM_UPDATED') {
        this.updateLineItemCommit(lineItem);
      } else if (updateType === 'LINE_ITEM_REMOVED') {
        this.deleteLineItemCommit(lineItem);
      } else if (updateType === 'LINE_ITEM_NOTE_UPDATED') {
        this.addLineItemNoteCommit(lineItem);
      }
      this.jobcard.quote.askForApproval = false; //Rerset approval request on any change
    }
  }

  addLineItemCommit(item: any) {
    var lineItem = {
      ...item,
      InvoiceID: this.jobcard.quote.id
    };

    this.invoiceService.addLineItem(lineItem).subscribe((invoice: any) => {
      this.mapOldQuoteToNewFormat(invoice);
      this.jobcard = { ...this.jobcard };
      this.manageInvoicePOSExtras();
      this.getUpdatedServiceTypes();      
    }, err => {
      console.error('Error adding line item:', err);
      this.getInvoice(null, true);
    });
  }

  updateLineItemCommit(item: any) {
    if (item.ID) {
      var data = {
        ...item,
        InvoiceID: this.jobcard.quote.id,
        LightSpeedDiscounts: this.lightSpeedDiscounts
      }

      this.invoiceService.updateLineItem(data).subscribe((invoice: any) => {
        this.mapOldQuoteToNewFormat(invoice);
        this.jobcard = { ...this.jobcard };
        this.manageInvoicePOSExtras();
        this.getUpdatedServiceTypes();
      }, err => {
        console.error('Error updating line item:', err);
        this.getInvoice(null, true);
      });
    }
  }

  deleteLineItemCommit(item: any) {
    this.invoiceService.deleteLineItem(this.jobcard.quote.id, item.ID).subscribe((invoice) => {
      this.mapOldQuoteToNewFormat(invoice);
      this.jobcard = { ...this.jobcard };
      this.manageInvoicePOSExtras();
      this.getUpdatedServiceTypes();
    }, err => {
      this.getInvoice(null, false);
      console.error('Error deleting line item:', err);
    });
  }

  addLineItemNoteCommit(item: any) {
    var data = {
      ...item,
      InvoiceID: this.jobcard.quote.id,
      LightSpeedDiscounts: this.lightSpeedDiscounts
    }

    this.invoiceService.UpdateInvoiceLineItemNote(data).subscribe((invoice: any) => {
      if(this.jobcard.quote.workOrderID){
        this.mapOldQuoteToNewFormat(invoice);
        this.manageInvoicePOSExtras();
      }
    }, err => {
      console.error('Error updating line item:', err);
    });
  }

  needsSpecialOrder() {
    // return this.jobcard.quote?.lineItems?.filter((x: any) => {
    //   return (
    //     x.OutOfStock &&
    //     x.SpecialOrderStatus === null &&
    //     x.StockOnHand <= 0
    //   )
    // }).length > 0 && this.canDoSpecialOrder;
    return this.jobcard.quote?.lineItems.filter((x: any) => {
      return x.SpecialOrderStatus === null;
    }).length > 0 && this.canDoSpecialOrder;
  }

  getLSDiscountPercentage(DiscountID: any) {
    if (this.lightSpeedDiscounts && this.lightSpeedDiscounts.length > 0 && DiscountID) {
      const discount = this.lightSpeedDiscounts.find((d) => d.ID === DiscountID.toString());
      if (discount && discount.DiscountPercent !== "0") {
        return (parseFloat(discount.DiscountPercent) * 100).toFixed(0);
      }
    }
    return 0;
  }

openWorkOrderURL(){
    switch (this.partnerData.POSSystemID) {
      case 6:
          window.open(
            `https://us.merchantos.com/?name=workbench.views.beta_workorder&form_name=view&id=${this.jobcard.quote.workOrderID}&tab=details`
          );
        break;
    }
}

  openPOSURL() {
    switch (this.partnerData.POSSystemID) {
      case 6:
        if (
          this.partnerData.POSCustomURL &&
          this.partnerData.POSCustomURL.indexOf('{{SALEID}}') > -1
        ) {
          window.open(
            this.partnerData.POSCustomURL.replace(
              '{{SALEID}}',
              this.jobcard.quote.externalKey,
            ),
          );
        } else {
          window.open(
            'https://us.merchantos.com/register.php?form_name=load_transaction&transaction_id=' +
            this.jobcard.quote.externalKey,
          );
        }
        break;
      case 8:
        window.open(
          'https://go.xero.com/organisationlogin/default.aspx?shortcode=' +
          this.shortCode +
          '&redirecturl=/AccountsReceivable/View.aspx?InvoiceID=' +
          this.jobcard.quote.externalKey,
        );
        break;
      case 13:
        window.open(
          'https://pos2.citruslime.com/pos2/#/pos/registerSelection?orderId=' +
          this.jobcard.quote.externalKey,
        );
        break;
      case 16:
        window.open(
          'https://system.netsuite.com/app/accounting/transactions/custinvc.nl?id=' +
          this.jobcard.quote.externalKey +
          '&whence=',
        );
        break;
    }
  }

  getShortCode() {
    if (this.partnerData.POSSystemID == 8) {
      this.partnerService
        .getOrganisationShortCode(this.jobcard.partnerID)
        .subscribe((res) => {
          this.shortCode = res;
        });
    }
  }

  openPOSURL_SalesOrder() {
    switch (this.partnerData.POSSystemID) {
      case 16:
        window.open(
          'https://system.netsuite.com/app/accounting/transactions/salesord.nl?id=' +
          this.jobcard.quote.synchFeedback.split('|')[0] +
          '&whence=',
        );
        break;
    }
  }

  getPOSName() {
    var value = this.appConfig.getSupportedPOSSystems().find((x) => {
      return x.POSID === this.partnerData.POSSystemID;
    });
    return value ? value.Name : 'POS';
  }

  openItemDetails(selectedItem = null) {
    if (selectedItem || (this.jobcard.selectedItem && this.jobcard.selectedItem.id)) {
      const modalRef = this.modalService.open(WorkshopJobcardUpdateCustomerItemComponent, {
        backdrop: true,
        backdropClass: 'jobcard-modal-popup-backdrop',
        windowClass: 'jobcard-modal-popup-window',
        size: 'xl'
      });

      modalRef.componentInstance.jobcard = this.jobcard;
      modalRef.componentInstance.item = selectedItem ? selectedItem : { ...this.jobcard.selectedItem, serialNo: this.jobcard.selectedItem.serialNumber || this.jobcard.selectedItem.serialNo };
      modalRef.componentInstance.partnerType = this.appConfig.getPartnerType();
      modalRef.componentInstance.partnerTypeID = this.helpersService.getPartnerData().PartnerType;
      modalRef.componentInstance.itemTypes = [];

      modalRef.result.then(
        (result) => {
          console.log('Modal closed with result:', result);
          if (result.selectedItem) {
            console.log(result);
            if (result.selectedItem && result.selectedItem.id === this.jobcard.selectedItem?.id) {
              this.jobcard.selectedItem = { ...result.selectedItem, serialNumber: result.selectedItem.serialNo, serialNo: null };
              this.jobcardChange.emit({ ...this.jobcard });
              this.getProject529Status();
            } 
          }
          else if (result.action === 'selectDifferentItem') {
            this.showCustomerItems();
          }
          else if (result.ownerChanged) {
            this.ownerChanged.emit(result.ownerChanged);
            console.log('Owner changed:', result.ownerChanged);
          }
        },
        (onrejected) => {
          console.log('Modal dismissed:', onrejected);
          this.jobcardChange.emit({ ...this.jobcard });
        },
      );
    }
  }

  showCustomerItems() {
    console.log('showCustomerItems');
    const modalRef = this.modalService.open(WorkshopJobcardListCustomerItemsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.jobCards = [];

    modalRef.result.then(
      (result) => {
        console.log(result);
        if (result.action === 'edit') {
          this.openItemDetails(result.selectedItem);
        } else if (result.action === 'create') {
          this.addItem();
        } else if (result.action === 'delete') {

        } else if (result.selectedItem && result.selectedItem.id > 0) {
          this.jobcard.selectedItem = result.selectedItem;
          this.jobcardChange.emit({ ...this.jobcard });
          this.serviceRequest.updateWorkshopJobCard(this.jobcard).subscribe((result) => {
            this.getProject529Status();
          });
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  addItem() {
    const modalRef = this.modalService.open(WorkshopJobcardAddCustomerItemComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.partnerType = this.appConfig.getPartnerType();
    modalRef.componentInstance.partnerTypeID = this.helpersService.getPartnerData().PartnerType;
    modalRef.componentInstance.itemTypes = [];

    modalRef.result.then(
      (result) => {
        if (result.selectedItem && result.selectedItem.id > 0) {
          this.jobcard.selectedItem = result.selectedItem;
          this.jobcardChange.emit({ ...this.jobcard });
          this.serviceRequest.updateWorkshopJobCard(this.jobcard).subscribe((result) => {
            this.getProject529Status();
          });
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  getProject529Status() {
    if (this.jobcard.id && this.partnerData.PartnerType == 1 && this.partnerData.Project529Enabled) {
      this.project529Service.getServiceProject529Status(this.jobcard.id).subscribe((status) => {
        this.jobcard.project529 = {
          ...status
        };
      });
    }
  }

  project529Action(status, event) {
    event.stopPropagation();
    if (status.status != 'Registered') {
      const modalRef = this.modalService.open(Project529ModalComponent, {
        //backdrop: 'static',
        backdropClass: 'project529-modal-background',
        windowClass: 'project529-modal-window',
      });
      modalRef.componentInstance.jobcard = { ID: this.jobcard.id, PartnerID: this.jobcard.partnerID, Email: this.jobcard.customer?.Email, SerialNo: this.jobcard.selectedItem?.serialNumber, project529: this.jobcard.project529 };
      modalRef.componentInstance.bike = { ID: this.jobcard.selectedItem?.id, Manufacturer: this.jobcard.selectedItem?.manufacturer, Model: this.jobcard.selectedItem?.model, ModelYear: this.jobcard.selectedItem?.modelYear };
      modalRef.componentInstance.messageService = this.messageService;
    }
  }

  onJobCardChange($event){
    this.jobcardChange.emit(this.jobcard);
  }

  getDurationFormatted(duration: number) {
    return this.workshopJobcardQuoteService.getDurationFormatted(duration);
  }

  sendNotesBroadcast(){
    if(this.useWorkOrdersForWorkshop){
      this.broadcastService.sendMessage({message: 'refresh-jobcard-notes'});
    }
  }
}
